module.exports = __webpack_public_path__ + "static/media/person-placeholder.b3b206a0.svg";